import { gsap } from "gsap";

// Animate the visual inside a stable hit area, independently from navigation motion.
export function magneticHover(
  host: HTMLElement,
  visual: HTMLElement = host,
  strength = 0.25,
  maxX = 22,
  maxY = 14,
  motion: {
    duration?: number;
    returnDuration?: number;
    returnEase?: string;
  } = {}
) {
  const x = gsap.quickTo(visual, "x", {
    duration: motion.duration ?? 0.35,
    ease: "power3.out",
  });
  const y = gsap.quickTo(visual, "y", {
    duration: motion.duration ?? 0.35,
    ease: "power3.out",
  });
  let returning: gsap.core.Tween | undefined;
  const move = (event: PointerEvent) => {
    if (event.pointerType !== "mouse") return;
    returning?.kill();
    const rect = host.getBoundingClientRect();
    const ownX = visual === host ? Number(gsap.getProperty(host, "x")) : 0;
    const ownY = visual === host ? Number(gsap.getProperty(host, "y")) : 0;
    x(
      gsap.utils.clamp(
        -maxX,
        maxX,
        (event.clientX - rect.left + ownX - rect.width / 2) * strength
      )
    );
    y(
      gsap.utils.clamp(
        -maxY,
        maxY,
        (event.clientY - rect.top + ownY - rect.height / 2) * strength
      )
    );
  };
  const leave = () => {
    x.tween.pause();
    y.tween.pause();
    returning?.kill();
    returning = gsap.to(visual, {
      x: 0,
      y: 0,
      duration: motion.returnDuration ?? 0.8,
      ease: motion.returnEase ?? "elastic.out(1,0.5)",
      // Keep the paused quickTo tweens reusable for the next pointer entry.
      overwrite: false,
    });
  };
  host.addEventListener("pointermove", move);
  host.addEventListener("pointerleave", leave);
  host.addEventListener("blur", leave);
  return () => {
    host.removeEventListener("pointermove", move);
    host.removeEventListener("pointerleave", leave);
    host.removeEventListener("blur", leave);
    returning?.kill();
    x.tween.kill();
    y.tween.kill();
    gsap.set(visual, { clearProps: "transform" });
  };
}
